import { ITncRepository } from '../../ports/ITncRepository';
import { TncCase } from '../../domain/entities';

export class UpdateEmployeeAvailabilityUseCase {
  constructor(private readonly tncRepository: ITncRepository) {}

  async execute(caseId: string, isPresent: boolean): Promise<TncCase> {
    return this.tncRepository.updateEmployeeAvailability(caseId, isPresent);
  }
}
